export enum PageWidth {
  veryVerySmall = 'veryVerySmall',
  verySmall = 'verySmall',
  small = 'small',
  medium = 'medium',
  large = 'large',
  veryLarge = 'veryLarge',
}
